import Toggle from 'components/Toggle';

import { NOT_FOUND_INDEX, TEST_ID } from './constants';
import type { FunctionComponent, IntervalUnit, Props } from './types';

import styles from './styles.module.scss';

const IntervalUnitToggle: FunctionComponent<Props> = ({
    className = '',
    isDisabled = false,
    onSelect,
    selectedUnit,
    testId = TEST_ID,
    units
}) => {
    const disabledClass = isDisabled ? styles.intervalUnitToggleDisabled : '';

    const selectedIndex = units.findIndex(({ value }) => value === selectedUnit);

    const handleClick = (unit: string) => onSelect(unit as IntervalUnit);

    return (
        <Toggle
            activeIndex={selectedIndex === NOT_FOUND_INDEX ? undefined : selectedIndex}
            className={`${className} ${disabledClass} ${styles.intervalUnitToggle}`}
            isDisabled={isDisabled}
            onClick={handleClick}
            options={units}
            testId={testId}
        />
    );
};

export default IntervalUnitToggle;
